import { ButtonList } from '@dixa/lib-shared-habla';
import { User } from 'lib-shared-types-api';
import { Channel } from 'lib-shared-types-channels';
import { useState } from 'react';

import { BanUserModal } from 'components/shared/banUserModal/banUserModal';
import { channelAttributes } from 'utils/channels';

export function BanUserButtonListItem({
  channel,
  user,
  onBan,
  csid,
  ipAddress,
  onModalOpen,
}: {
  user: User;
  channel: Channel;
  onModalOpen?: VoidFunction;
  csid?: number;
  ipAddress?: string;
  onBan?: () => void;
}): JSX.Element {
  const [isModalOpen, setModalOpen] = useState(false);

  function handleOnModalClose(canceled: boolean) {
    setModalOpen(false);

    if (!canceled) {
      onBan?.();
    }
  }

  function handleOnModalOpen() {
    setModalOpen(true);
    onModalOpen && onModalOpen();
  }

  return (
    <>
      <ButtonList.Item icon="ban" onClick={handleOnModalOpen}>
        Ban from {channelAttributes[channel]?.name ?? 'Unknown'}
      </ButtonList.Item>
      <BanUserModal
        user={user}
        channel={channel}
        csid={csid}
        ipAddress={ipAddress}
        isOpen={isModalOpen}
        onClose={handleOnModalClose}
      />
    </>
  );
}
